var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"barChart Chart",class:{ratio_class : _vm.useData.id == 'barChart4'},attrs:{"id":_vm.useData.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }